import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
    overflow-x: hidden;
    width: 100%;
  }

  body {
    font-family: ${({ theme }) => theme.fonts.primary};
    background-color: ${({ theme }) => theme.colors.background.light};
    color: ${({ theme }) => theme.colors.text.dark};
    line-height: 1.6;
    overflow-x: hidden;
    padding-top: 110px;
    margin: 0;

    @media (max-width: 768px) {
      padding-top: 70px;
    }
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  ul, ol {
    list-style: none;
  }

  button, input, textarea, select {
    font-family: inherit;
    font-size: inherit;
  }

  button {
    cursor: pointer;
    border: none;
    background: none;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-weight: 600;
    line-height: 1.3;
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }

  h1 {
    font-size: ${({ theme }) => theme.fontSizes.xxxl};
  }

  h2 {
    font-size: ${({ theme }) => theme.fontSizes.xxl};
  }

  h3 {
    font-size: ${({ theme }) => theme.fontSizes.xl};
  }

  p {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }

  section {
    padding: ${({ theme }) => theme.spacing.xxl} 0;
  }

  .container {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 ${({ theme }) => theme.spacing.md};
  }

  /* Utility classes */
  .text-center {
    text-align: center;
  }

  .mb-sm {
    margin-bottom: ${({ theme }) => theme.spacing.sm};
  }

  .mb-md {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }

  .mb-lg {
    margin-bottom: ${({ theme }) => theme.spacing.lg};
  }

  .mt-sm {
    margin-top: ${({ theme }) => theme.spacing.sm};
  }

  .mt-md {
    margin-top: ${({ theme }) => theme.spacing.md};
  }

  .mt-lg {
    margin-top: ${({ theme }) => theme.spacing.lg};
  }
`;

export default GlobalStyle;
